import { Component } from '@angular/core';

/**
 * Kept for backward compatibility. Silent token renewal is now handled
 * internally by angular-auth-oidc-client via the silentRenewUrl iframe.
 */
@Component({
    selector: 'auth-refresh',
    template: '',
    standalone: false
})
export class AuthRefreshComponent { }

